import {PropsWithChildren} from 'react';
import styled from 'styled-components';
import {down, up} from 'styled-breakpoints';
import {ifProp} from 'styled-tools';

const Main = styled.main<{full?: boolean}>`
  display: flex;
  align-self: center;
  flex-grow: 1;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  margin: 0 auto;
  min-height: 200px;
  ${down('sm')} {
    margin-top: 80px;
  }
  ${up('md')} {
    margin-top: ${ifProp('full', '', '20px')};
  }
  ${up('lg')} {
    margin-top: ${ifProp('full', '', '20px')};
  }

  > div {
    width: 100%;
  }
`;

const Wrapper = styled.div<{variant?: string}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  min-height: 100vh;
  overflow: auto;
  ${down('sm')} {
    padding: ${({variant}) =>
      ['auth', 'full'].includes(variant || '') ? '' : ' 0 16px 0'};
  }

  ${up('md')} {
    padding: ${({variant}) =>
      ['auth', 'full'].includes(variant || '') ? '' : ' 0 80px 0'};
  }
`;

// Do not delete
// const Footer = styled.footer`
//   display: flex;
//   flex-wrap: wrap;
//   width: 100%;
//   align-content: center;
//   justify-content: center;
//   margin: 32px 0;
//   padding: 0;
//   border: none;
//   text-align: center;
// `;

// DO NOT DELETE
// const FooterItem = styled.div`
//   display: inline-block;
//   margin-right: 16px;
//   margin-bottom: 5px;
// `;
// const ExternalLink = styled.a`
//   text-decoration: none;
//   color: rgb(94, 94, 115);
//   font-size: 14px;
//   transition: all 300ms ease-in-out 0s;
// `;

export function AuthTemplate({children, variant}: PropsWithChildren<{}> | any) {
  return (
    <Wrapper variant={variant}>
      <Main full={variant === 'full'}>{children}</Main>
      {/* <Footer> */}
      {/* <FooterItem> // DO NOT DELETE COMMENT
          <ExternalLink href="https://www.peoplebeam.co/terms" target="_blank">
            Beam Terms of Use
          </ExternalLink>
        </FooterItem>
        <FooterItem>
          <ExternalLink href="https://www.peoplebeam.co/privacy" target="_blank">
            Privacy Policy
          </ExternalLink>
        </FooterItem> */}
      {/* </Footer> */}
    </Wrapper>
  );
}
